import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

export function resolveS3Url(url: string | null | undefined): string {
  if (!url) return "";
  const match = url.match(/^https?:\/\/[^/]*s3[^/]*\.amazonaws\.com\/(.+)$/i);
  if (match) return `${API_BASE_URL}/s3/${match[1]}`;
  return url;
}

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
